import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, inject, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {LayoutComponent} from './component/layout/layout.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SecurityContextHolder} from './security/context/security-context-holder';
import {GlobalErrorHandler} from './core/global-error-handler';
import {CookieService} from 'ngx-cookie-service';
import {httpInterceptorProviders} from './security';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {IonicStorageModule} from '@ionic/storage-angular';
import {DirectiveModule} from './directive/directive.module';
import {LogoutModalComponent} from './component/logout-modal/logout-modal.component';
import {PromptModalModule} from './component/prompt-modal/prompt-modal.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {initializeAppFactory} from './core/app.initializer';
import { SupportModalComponent } from './component/support-modal/support-modal.component';
import { ModalModule } from './component/modal/modal.module';

@NgModule({
  declarations: [AppComponent, LogoutModalComponent, SupportModalComponent, LayoutComponent],
  imports: [BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    PromptModalModule,
    BrowserAnimationsModule,
    DirectiveModule],
  providers: [
    { provide: APP_INITIALIZER, useFactory: initializeAppFactory, deps: [SecurityContextHolder], multi: true },
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    CookieService, httpInterceptorProviders, provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent],
  exports: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class AppModule {}
